import { Backdrop, CircularProgress } from "@mui/material"
import { createContext, useState } from "react"

export const LoadingPageContext = createContext()

export const LoadingPageProvider = ({ children }) => {
    const [loadingPage_, setLoadingPage_] = useState(false)

    const setLoadingPage = (bol_) => {
        const bol = (typeof bol_ == "boolean" ? bol_ : false)
        setLoadingPage_(bol)
    }

    const value = {
        LoadingPage: setLoadingPage
    }
    return (
        <LoadingPageContext.Provider value={value}>
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loadingPage_}
                    onClick={() => {}}
                >
                    <CircularProgress color="inherit" size="96px" />
                </Backdrop>

                {children}
            </div>
        </LoadingPageContext.Provider>
    )
}
